var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[(_vm.showHeader)?_c('Header'):_vm._e(),_c('div',{staticClass:"body",class:[_vm.layout || '']},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }